var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveWeeklyProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5787 12.0526L16.2629 7.84204M13.105 14.1578C13.105 15.3206 12.1625 16.2631 10.9998 16.2631C9.83706 16.2631 8.89453 15.3206 8.89453 14.1578C8.89453 12.9951 9.83706 12.0526 10.9998 12.0526C12.1625 12.0526 13.105 12.9951 13.105 14.1578Z",
    stroke: "url(#paint0_linear_7946_60674)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68359 10.9999C4.68359 7.51175 7.51126 4.68408 10.9994 4.68408C12.1498 4.68408 13.2283 4.99164 14.1573 5.52902",
    stroke: "url(#paint1_linear_7946_60674)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11C1 6.28595 1 3.92893 2.46446 2.46446C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46446C21 3.92893 21 6.28595 21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46446 19.5355C1 18.0711 1 15.714 1 11Z",
    stroke: "url(#paint2_linear_7946_60674)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7946_60674",
    x1: 10.7229,
    y1: 8.34747,
    x2: 15.1393,
    y2: 15.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7946_60674",
    x1: 7.03432,
    y1: 5.06315,
    x2: 9.44988,
    y2: 11.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7946_60674",
    x1: 5.96266,
    y1: 2.20038,
    x2: 15.843,
    y2: 19.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWeeklyProgress);
export default __webpack_public_path__ + "static/media/ActiveWeeklyProgress.a278ecdb0d2409d7337f9bc37547875b.svg";
export { ForwardRef as ReactComponent };